import { createContext, useState } from 'react'
import '@/App.css'
import SearchConditionView from '@/views/SearchConditionView'
import ResultAreaView from '@/views/ResultAreaView'
import { useAPIConnection } from '@/customHooks/useAPIConnection'
import { usePagination } from '@/customHooks/usePagination'
import { useSearchCondition } from '@/customHooks/useSearchCondition'
import { API, SearchCondition } from '@/types/Types'
import Ad from './views/Ad'
//import axios from 'axios'
//axios.get('searchTMapInfo.php?boxA[]=6_0&boxB[]=6_0&boxC[]=4_0&mapRank[]=B5_0&limit=100&offset=0')

export const APIContext = createContext({} as API)

export const SearchConditionContext = createContext({} as SearchCondition)

const App = () => {
  // #region フック

  const api = useAPIConnection()

  const searchCondition = useSearchCondition()

  const pagination = usePagination(api, searchCondition)

  const [is234] = useState(() => Math.random() < 0.5)

  // #endregion フック

  // #region スタイル

  const adAreaStyle: React.CSSProperties = {
    textAlign: 'center'
  }

  const adHeadlineStyle: React.CSSProperties = {
    margin: '8px 0 0 0',
    fontSize: '20px',
    fontFamily: 'Meiryo',
    fontWeight: 'bold'
  }

  const adMainStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center'
  }

  const hrStyle: React.CSSProperties = {
    marginLeft: '18px'
  }

  const spaceStyle: React.CSSProperties = {
    marginLeft: '10px'
  }

  const displayStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column'
  }

  const searchConditionStyle: React.CSSProperties = {
    height: '225px'
  }

  const resultAreaStyle: React.CSSProperties = {
    height: 'calc(100vh - 540px)'
  }

  // #endregion スタイル

  return (
    <APIContext.Provider value={api}>
      <SearchConditionContext.Provider value={searchCondition}>
        <div style={adAreaStyle}>
          <p style={adHeadlineStyle}>広告</p>
          {is234 ? (
            <div style={adMainStyle}>
              <Ad width={234} height={60} />
              <Ad width={234} height={60} />
              <Ad width={234} height={60} />
            </div>
          ) : (
            <div style={adMainStyle}>
              <Ad width={468} height={60} />
              <Ad width={468} height={60} />
            </div>
          )}
        </div>
        <hr style={hrStyle} />
        <div style={spaceStyle}>
          <h1>ドラゴンクエスト9 宝の地図データベース検索ツール</h1>
          <div style={spaceStyle}>
            ドラクエ9にて正規入手可能な宝の地図（389592種類）を指定した条件で検索します。
            <br />
            特殊フロア判定（特に敵減・敵無）についてはデータが正しくない可能性があります。
            <hr />
            <div style={displayStyle}>
              <div style={searchConditionStyle}>
                <SearchConditionView />
              </div>
              <div style={resultAreaStyle}>
                <ResultAreaView pagination={pagination} />
              </div>
            </div>
            <hr />
            <a href='/tools'>ツール置き場に戻る</a>
            {'　|　'}
            <a href='/'>トップページに戻る</a>
            {'　|　'}
            <a href='/blog/hello-world'>運営者情報</a>
            {'　|　'}
            <a href='/blog/privacypolicy'>プライバシーポリシー</a>
          </div>
        </div>
      </SearchConditionContext.Provider>
    </APIContext.Provider>
  )
}

export default App
